<article class="card-details">
  <button
    type="button"
    class="card-details__close-button"
    mat-dialog-close
    [matTooltip]="'Fermer'"
    aria-label="Fermer"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="m6.4 18.308l-.708-.708l5.6-5.6l-5.6-5.6l.708-.708l5.6 5.6l5.6-5.6l.708.708l-5.6 5.6l5.6 5.6l-.708.708l-5.6-5.6z"
      />
    </svg>
  </button>

  <section>
    <hgroup class="card-details__header">
      <h2>Gérer mon abonnement</h2>
    </hgroup>

    @if (
      {
        currentSubscription: currentSubscription$ | async
      };
      as STATE
    ) {
      <article class="card-details__table__wrapper">
        @if (STATE.currentSubscription) {
          <div>
            <h2 class="py-4 text-xl font-bold">
              {{ STATE.currentSubscription.subscriptionPlan.name }}
            </h2>
            <p>
              Période :
              {{
                STATE.currentSubscription.subscriptionPlan.duration
                  | subscriptionPlanDuration
              }}
            </p>
            <p>
              Date de renouvellement :
              {{ STATE.currentSubscription.endDate | date: 'dd/MM/yyyy' }}
            </p>
          </div>

          <div class="py-4">
            <p>Avantages liés à cette offre</p>
            <ul class="space-y-2">
              @for (
                advantage of STATE.currentSubscription.subscriptionPlan
                  .advantages;
                track advantage
              ) {
                <li class="card-details__advantage-wrapper">
                  <img
                    src="assets/icons/check-primary.svg"
                    alt="check icon"
                    class="card-details__icon-check"
                  />
                  <span>{{ advantage.name }}</span>
                </li>
              } @empty {
                <li>Aucun avantage spécifié</li>
              }
            </ul>
          </div>
        } @else {
          <div>
            <h2 class="py-4 text-xl font-bold">Aucun abonnement actif</h2>
          </div>
        }
      </article>
    }
  </section>
</article>
